import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const TILE_COLORS = ["mint", "uv", "gold", "yellow", "pink", "orange", "blue", "mint"];

const HomeDivisions = ({ divisions, tournamentName }) => {
  const seasonLabel = React.useMemo(() => {
    if (!tournamentName) return "TEMPORADA";
    const match = tournamentName.match(/Temporada\s*(\d+)/i);
    if (match) return `TEMPORADA ${match[1]}`;
    return "TEMPORADA";
  }, [tournamentName]);
  const navigate = useNavigate();

  const handleClick = (division) => {
    if (division.groups && division.groups.length === 1) {
      const groupId = division.groups[0].groupId;
      navigate(`/division/${division.divisionId}/group/${groupId}`);
    } else if (division.groups && division.groups.length > 1) {
      const groupId = division.groups[0].groupId;
      navigate(`/division/${division.divisionId}/group/${groupId}`);
    }
  };

  if (!divisions || divisions.length === 0) return null;

  return (
    <Wrapper className="v-anim-fade-up v-delay-2">
      <SectionLabel>{seasonLabel}</SectionLabel>
      <SectionTitle>DIVISIONES</SectionTitle>
      <Grid>
        {divisions.map((division, i) => (
          <Tile
            key={division.divisionId}
            className={TILE_COLORS[i % TILE_COLORS.length]}
            onClick={() => handleClick(division)}
          >
            {division.image && (
              <DivImg
                src={division.image}
                alt={division.name}
                loading="lazy"
              />
            )}
            <DivName>{division.name}</DivName>
          </Tile>
        ))}
      </Grid>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  width: 100%;
  opacity: 0;
`;

const SectionLabel = styled.p`
  font-family: var(--v-font-mono);
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1.8px;
  color: var(--v-mint);
  margin: 0 0 0.25rem 0;
`;

const SectionTitle = styled.h2`
  font-family: var(--v-font-ui);
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
  color: var(--v-white);
  margin: 0 0 1rem 0;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 0.5rem;

  @media (max-width: 1000px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (max-width: 700px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 450px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const Tile = styled.div`
  border-radius: 12px;
  padding: 0.75rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  cursor: pointer;
  transition: transform var(--v-transition), opacity var(--v-transition);
  min-height: 80px;

  &.mint { background: var(--v-mint); color: var(--v-black); }
  &.uv { background: var(--v-uv); color: var(--v-white); }
  &.gold { background: var(--v-gold); color: var(--v-black); }
  &.yellow { background: var(--v-yellow-tile); color: var(--v-black); }
  &.pink { background: var(--v-pink-tile); color: var(--v-white); }
  &.orange { background: var(--v-orange-tile); color: var(--v-white); }
  &.blue { background: var(--v-blue-tile); color: var(--v-white); }

  &:hover {
    transform: translateY(-2px);
    opacity: 0.85;
  }
`;

const DivImg = styled.img`
  width: 2.2rem;
  height: 2.2rem;
  object-fit: contain;
  border-radius: 6px;
`;

const DivName = styled.span`
  font-family: var(--v-font-ui);
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  line-height: 1.2;
`;

export default HomeDivisions;
